import { render, staticRenderFns } from "./GroupSearchPost.vue?vue&type=template&id=50dd0af8&scoped=true&"
import script from "./GroupSearchPost.vue?vue&type=script&lang=js&"
export * from "./GroupSearchPost.vue?vue&type=script&lang=js&"
import style0 from "./GroupSearchPost.vue?vue&type=style&index=0&id=50dd0af8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dd0af8",
  null
  
)

export default component.exports